
import * as apifetch from '../fetch.js';

export async function createNewOrder() {
    const urlEndpoint = 'orders/new';

    return apifetch.kkFetch(urlEndpoint, 'POST');
}

export async function updateOrder(orderId, data) {
    const urlEndpoint = 'orders/' + orderId + '/update';

    const postData = data;

    return apifetch.kkFetch(urlEndpoint, 'PUT', postData);
}

export async function getOrderAddress(orderId) {
    const urlEndpoint = 'orders/' + orderId + '/address';

    return apifetch.kkFetch(urlEndpoint, 'GET');
}

export async function submitOrder(cartId) {
    const urlEndpoint = 'orders/' + cartId + '/submit';

    const postData = {};

    return apifetch.kkFetch(urlEndpoint, 'POST', postData);
}



